import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import ExpandCollapseButton from "@entrilia/shared/components/ExpandCollapseButton";
import RoundedTable from "@entrilia/shared/components/RoundedTable";
import CollapseAllIcon from "@entrilia/shared/icons/CollapseAllIcon";
import ExpandAllIcon from "@entrilia/shared/icons/ExpandAllIcon";
import type { MemberChange } from "../membersChangeRequestHelper";
import MemberChangeRow from "./MemberChangeRow";

interface Props {
  changes: MemberChange[];
}

const MemberChangesTable = ({ changes }: Props) => {
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);

  const allExpanded = changes.every((change) => expandedKeys.includes(change.key));

  const handleToggleAllClick = () => {
    setExpandedKeys(allExpanded ? [] : changes.map((change) => change.key));
  };

  const handleToggle = (changeKey: string) => {
    setExpandedKeys((keys) =>
      keys.includes(changeKey) ? keys.filter((key) => key !== changeKey) : [...keys, changeKey]
    );
  };

  return (
    <RoundedTable withoutColumnBorders>
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: 48, px: 0.75 }}>
            <ExpandCollapseButton
              expanded={allExpanded}
              onToggle={handleToggleAllClick}
              ExpandIcon={ExpandAllIcon}
              CollapseIcon={CollapseAllIcon}
              sx={{ my: -1 }}
              aria-label="Toggle all member change details"
            />
          </TableCell>
          <TableCell>Name</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {changes.map((change) => (
          <MemberChangeRow
            key={change.key}
            change={change}
            expanded={expandedKeys.includes(change.key)}
            onToggleExpanded={() => handleToggle(change.key)}
          />
        ))}
      </TableBody>
    </RoundedTable>
  );
};

export default MemberChangesTable;
